import styled from 'styled-components'
import { style } from 'styled-system'

const sticky = style({
    prop: 'sticky',
    key: 'sticky',
    transform: (val) => val ? 'sticky' : 'relative',
    cssProperty: 'position',
})

const top = style({
    prop: 'top',
    key: 'top',
    cssProperty: 'top',
})

export const Sticky = styled.div`
    ${sticky}
    ${top}
    position: sticky;
    z-index: ${({ zIndex }) => zIndex};
`

Sticky.defaultProps = {
    top: '0',
    sticky: true,
    zIndex: 'auto',
}

export const StickyContainer = styled.div`
    height: 100%;
    width: 100%;
`
